import React, { useEffect } from "react";

interface ToastProps {
  message: string;
  type: "success" | "error" | "warning";
  onClose: () => void;
}

const bgColors = {
  success: "bg-green-500",
  error: "bg-red-500",
  warning: "bg-yellow-500",
};

export default function Toast({ message, type, onClose }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`fixed top-6 right-6 px-5 py-3 text-white rounded-lg shadow-lg text-sm flex items-center gap-2 animate-slide-in z-[100] ${bgColors[type]}`}
    >
      {type === "success" && "✔️"}
      {type === "error" && "❌"}
      {type === "warning" && "⚠️"}
      <span>{message}</span>
    </div>
  );
}
